// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__T8vMA","dragIcon":"Choice_dragIcon__2DWup","left":"Choice_left__3uknl","input":"Choice_input__3cZPk"};